import { useEffect, useRef } from 'react';

export default function LeavesCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let W, H;

    const resize = () => {
      W = canvas.width = window.innerWidth;
      H = canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    const LEAF_SHAPES = ['🍃', '🌿', '🍀', '🌱'];
    const leaves = Array.from({ length: 22 }, () => ({
      x: Math.random() * window.innerWidth,
      y: Math.random() * -window.innerHeight,
      size: 12 + Math.random() * 20,
      speed: 0.5 + Math.random() * 1.3,
      driftSpeed: 0.008 + Math.random() * 0.02,
      rot: Math.random() * 360,
      rotSpeed: (Math.random() - 0.5) * 1.8,
      shape: LEAF_SHAPES[Math.floor(Math.random() * LEAF_SHAPES.length)],
      phase: Math.random() * Math.PI * 2,
      opacity: 0.35 + Math.random() * 0.45,
    }));

    let raf;
    function draw() {
      ctx.clearRect(0, 0, W, H);
      leaves.forEach(l => {
        l.y += l.speed;
        l.phase += l.driftSpeed;
        l.x += Math.sin(l.phase) * 1.4;
        l.rot += l.rotSpeed;
        if (l.y > H + 50) { l.y = -60; l.x = Math.random() * W; }
        ctx.save();
        ctx.globalAlpha = l.opacity;
        ctx.translate(l.x, l.y);
        ctx.rotate(l.rot * Math.PI / 180);
        ctx.font = l.size + 'px serif';
        ctx.textAlign = 'center';
        ctx.fillText(l.shape, 0, 0);
        ctx.restore();
      });
      raf = requestAnimationFrame(draw);
    }
    draw();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 0,
        opacity: 0.38,
      }}
    />
  );
}
